// extracted by mini-css-extract-plugin
export default {"Rating":"Rating_Rating__ZWNjN","Rating__progress__theme":"Rating_Rating__progress__theme__NTRjO"};